// api/core/apiClient.ts
import axios, { type AxiosInstance } from 'axios';

/**
 * Dynamically determine API base URL based on current domain
 * This allows the same build to work on both infinitum8.com and adinfinitum8.com
 */
const getApiBaseUrl = (): string => {
    // In development, use the environment variable or local default
    if (import.meta.env.DEV) {
        return import.meta.env.VITE_API_BASE_URL || 'http://localhost:8000';
    }

    // In production, derive from current domain
    const currentHost = window.location.host;
    return `https://${currentHost}/api`;
};

const API_BASE_URL = getApiBaseUrl();

export const baseApiClient: AxiosInstance = axios.create({
    baseURL: API_BASE_URL,
    headers: { 'Content-Type': 'application/json' },
    withCredentials: true, // Send cookies with requests
    timeout: 30000, // 30 seconds
});

// We'll attach the interceptors to this later and export it
export let apiClient: AxiosInstance = baseApiClient;

// We'll create a function to set the apiClient from outside
export const setApiClient = (client: AxiosInstance): void => {
    apiClient = client;
};
